import { Route, Routes } from "react-router-dom";
import routes from "./routes";
import ErrorPage from "./pages/error/error";
import Dashboard from "./dashboard/dashboard";
import RequestContextProvider from "./context/request.context";
import LoginPage from "./pages/login/login";

function App() {
  return (
    <Routes>
      {routes.map((route) => (
        <Route
          key={route.name}
          path={route.path}
          element={
            <RequestContextProvider>
              <Dashboard children={route} />
            </RequestContextProvider>
          }
        />
      ))}
      <Route path="/login" element={<LoginPage />} />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}

export default App;
